import css from 'styled-jsx/css';

const styles = css.global`#page-emprestimo-garantia-contrato {
    display: none;
}

#page-emprestimo-garantia-contrato.show {
    display: block;
}

@media (min-width: 1280px) {
    .ctn-home-24 {
        padding-right: 0;
        padding-left: 0;
    }
  }`;

export default styles;